import type { EquivalentProductGroupFormValues } from "./forms/equivalentProductGroupSchema"

import type {
  EquivalencyGroup,
  EquivalencyGroupCreateInput,
  EquivalencyGroupUpdateInput,
} from "@/graphql/codegen/graphql"

export const serializeCreateInput = (formValues: EquivalentProductGroupFormValues): EquivalencyGroupCreateInput => {
  return {
    name: formValues.name.trim(),
    type: formValues.type,
    notes: formValues.notes.trim(),
  }
}

export const serializeUpdateInput = (
  formValues: EquivalentProductGroupFormValues,
  equivalencyGroupId: string
): EquivalencyGroupUpdateInput => {
  return {
    equivalencyGroupId,
    name: formValues.name.trim(),
    notes: formValues.notes.trim(),
  }
}

export const buildDefaultFormValues = (data: EquivalencyGroup): EquivalentProductGroupFormValues => {
  return {
    equivalencyGroupId: data.equivalencyGroupId,
    name: data.name,
    type: data.type,
    notes: data.notes || "",
  }
}
